'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrowThickDown = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M21.718 13.716a1 1 0 0 0-.924-.616H15.75a.25.25 0 0 1-.25-.25V1.1a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v11.75a.25.25 0 0 1-.25.25H3.206a1 1 0 0 0-.706 1.707l8.794 8.8a1 1 0 0 0 1.415 0l8.793-8.8a1 1 0 0 0 .216-1.091z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 23.899a.996.996 0 0 1-.707-.292l-8.795-8.801a.993.993 0 0 1-.293-.706c0-.268.103-.519.292-.708a.995.995 0 0 1 .708-.294H8v-12c0-.551.449-1 1-1h6c.552 0 1 .449 1 1v12h4.794a1 1 0 0 1 .706 1.708l-8.792 8.8a.994.994 0 0 1-.708.293zm.001-.999l8.793-8.8h-5.293a.5.5 0 0 1-.5-.5V1.1H9v12.5a.5.5 0 0 1-.5.5H3.206l8.795 8.8z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.002 24a1.498 1.498 0 0 1-1.168-.55L2.581 12.936a1.48 1.48 0 0 1-.329-.951A1.504 1.504 0 0 1 3.751 10.5H6.75v-9C6.753.672 7.428 0 8.253 0h7.491c.829 0 1.503.672 1.506 1.497V10.5h2.992a1.502 1.502 0 0 1 1.499 1.35 1.49 1.49 0 0 1-.331 1.099l-8.233 10.488c-.071.086-.14.156-.215.219a1.523 1.523 0 0 1-.96.344zM3.751 12.001l8.252 10.509 8.236-10.5L16.5 12a.75.75 0 0 1-.75-.75V1.5H8.256l-.006 9.75a.75.75 0 0 1-.75.75H3.754l-.003.001z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowThickDown.displayName = 'IconArrowThickDown';
exports.default = IconArrowThickDown;